import * as React from "react";
const SvgAlkosto = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <rect width={32} height={32} fill="url(#Alkosto_svg__a)" rx={8} />
    <defs>
      <pattern
        id="Alkosto_svg__a"
        width={1}
        height={1}
        patternContentUnits="objectBoundingBox"
      >
        <use xlinkHref="#Alkosto_svg__b" transform="scale(.03571)" />
      </pattern>
      <image
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHKADAAQAAAABAAAAHAAAAABkvfSiAAACoUlEQVRIDb2WQWgTQRSG327WJDSpWkVKlYIFURHpqSfpRfSgKAhSBS9FBMWbgl6VUjwL3goVCSI9SL212IPiRUWhpyKlB6FC0RJEi+0aknWTdf7ZncnuMrub3UAG0nmZefO+vjfvvYlWnTw6R6Rdo14Mh15p1cljTi9YgqELoVezoQS1bCK73t7Kl105vI5Vo0ikq820DbQlpaYxdIT0gUGpZa19JgKMGc6PnpHrQvDvi7WoOQj0jPadv0GFsbP8zL/1VWptVcne+EKly/epOH6J9PIeaa+x/IY4UK7EC0EgdBlU33+QtP59/GTuwCE+wzPAckMj/Dv+NDfXqfb6mfRebsQIHSUNwtt34WYA5uz8pp3KFPc8zR0mAhE+wPKj44H/u7b0nKyVt0QioQK70V8SgQhtGGatvKe/CzNuhkbbVu4kAsOnEMra4iyRZaYqB2EnNVAczDqnBiLE/den3LtDGaUciUCEsP7uJS8BYRulsffeU7cbpYQmAlvmH9quPCRz/gkBLgYSafetx+49poAmAgEwBg9T4+M8oRT8UHSj0sXbqaBKYOvXDx5CdJLmz+/CKV4KaGVi4D7RfQpj59ylDjwNtjZ0fXao/mmRf4Rhu/rNrTlWCmhlaH2iNnGf5Yk75JhbZK1+EEciZ/UDjBoTI/z8sD1j+CQNPJiT/RaqaAbmi0dkb36NrU9lSHm7QsvCJ/zWsTW8HNuV6cB9wmO8Mlw/JrRqoPAuamZeN5aXeBL5VYqnr7pJ5H+8/QpMzgb0vEY/RY36R+nKXSqcmnBbn3/Dk4NJo1CIXWKhE0m0a+SEVEUSNTfWlPfZHZAhkCRIltzwcQmME7oDeqEFFIkUGOHs9ja7AwoCwB0+xNmSRoAyzDqxn98ZzmU6opGz8B8ruOZGE5spDgAAAABJRU5ErkJggg=="
        id="Alkosto_svg__b"
        width={28}
        height={28}
        preserveAspectRatio="none"
      />
    </defs>
  </svg>
);
export default SvgAlkosto;
